module.exports = __webpack_public_path__ + "media/images/residential-f407891d5b339b9a9762ac9f8c6b5be7.svg";